import React, { forwardRef, useEffect, useState } from 'react';
import { TextField, TextFieldProps } from '../main';
import noop from 'lodash/noop';

type ChangeMethod = TextFieldProps['onChange'];

const asNumber = (text: string): string => {
  const noneCommaText = clean(text);
  const parsedNum = parseFloat(noneCommaText);

  return isNaN(parsedNum) ? '' : parsedNum.toLocaleString();
};

const clean = (text: string) =>
  (typeof text !== 'string' ? String(text) : text).replace(/\D/g, '');

export const NumericTextField = forwardRef<HTMLInputElement, TextFieldProps>(
  (
    {
      type,
      children,
      value,
      autoComplete = 'off',
      onChange = noop,
      ...fieldProps
    },
    ref,
  ) => {
    const [inputValue, setInputValue] = useState(asNumber(value as string));

    useEffect(() => {
      setInputValue(asNumber(value as string));
    }, [value]);

    const handleChange: ChangeMethod = (value, options) => {
      const parsedValue = asNumber(value);
      setInputValue(parsedValue);
      onChange(clean(parsedValue), options);
    };

    return (
      <TextField
        {...fieldProps}
        ref={ref}
        value={inputValue}
        onChange={handleChange}
        type={'text'}
        autoComplete={autoComplete}
      >
        {children}
      </TextField>
    );
  },
);
